// Single source for the Customers menu, the industry routes and their pages.
const img = (name) => `images/${name}`

export default [
  {
    path: '/health',
    name: 'Health',
    menu: 'Health Tech',
    title: 'Health Tech',
    lede: 'Devices, data, and care delivery.',
    companies: [
      { name: 'Pria by Black + Decker', url: 'https://www.okpria.com/', image: 'p5.jpg',
        text: 'Partner Management and Delivery for new product from Stanley.' },
      { name: 'RxBenefits', url: 'https://www.rxbenefits.com/', image: 'rxBenefits.jpg',
        text: 'Data and Data Science Strategy for a leading Pharma Benefits manager.' },
      { name: 'Benefits Science', url: 'https://www.benefitsscience.com', image: 'benefitscience.jpg',
        text: 'Product and operations growth strategy for a benefits optimization analytics provider.' },
      { name: 'Mella AI', url: 'https://www.mella.ai/', image: 'Mela.JPG',
        text: 'Product and operations strategy to grow a seed stage pet health company.' }
    ]
  },
  {
    path: '/edtech',
    name: 'EdTech',
    menu: 'Education Tech',
    title: 'Education Tech',
    lede: 'Learning products that scale.',
    companies: [
      { name: 'English Central', url: 'https://www.englishcentral.com/', image: 'p2.png',
        text: 'Product Strategy, Operational Execution for the leading video English learning company.' },
      { name: 'Cognii', url: 'https://cognii.com/', image: 'p8.jpg',
        text: 'Strategy, Funding, Staffing for an intelligent grading system.' }
    ]
  },
  {
    path: '/martech',
    name: 'Martech',
    menu: 'Marketing Tech',
    title: 'Marketing Tech',
    lede: 'Performance marketing and advertising platforms.',
    companies: [
      { name: 'Course Advisor', url: 'https://digitalmediasolutions.com/education', image: 'courseadvisor-share-image.jpg',
        text: 'CEO of one of the top education lead generation companies.' },
      { name: 'Nanigans', url: 'http://nanigans.com/', image: 'NanigansLogo.jpg',
        text: 'Strategy and fund raising for restructure for one of the top social advertising platforms.' }
    ]
  },
  {
    path: '/robotics',
    name: 'Robotics',
    menu: 'Robotics',
    title: 'Robotics',
    lede: 'Social robots, devices, and lab automation.',
    companies: [
      { name: 'Pillo Health', url: 'https://pillohealth.com/', image: 'p3.jpg',
        text: 'Business Strategy, Fund Raising, Operational Execution for a unique social medication dispenser.' },
      { name: 'Jibo', url: 'https://www.jibo.com/', image: 'p4.jpg',
        text: 'Technical Architecture, Operational Execution, Fund Raising, Business Strategy for the first and leading social robot.' },
      { name: 'Artificial', url: 'https://www.artificial.com/', image: 'smartlab.jpg',
        text: 'Product Definition for AI automation of biology labs.' }
    ]
  },
  {
    path: '/enterprise',
    name: 'Enterprise',
    menu: 'Enterprise',
    title: 'Enterprise',
    lede: 'Software and operations for large markets.',
    companies: [
      { name: 'Thras.io', url: 'https://thras.io/', image: 'p1.png',
        text: 'Product and Operational Execution for the largest acquirer of Amazon third party sellers.' },
      { name: 'Nuance', url: 'https://www.nuance.com/', image: 'nuance.png',
        text: 'VP of Product for the leading speech technology company.' }
    ]
  }
].map((i) => ({ ...i, companies: i.companies.map((c) => ({ ...c, image: img(c.image) })) }))
